import React from 'react';
import MiPanelContent from './components/MiPanelContent';

const Panel = props => (
  <MiPanelContent {...props} />
);

export default Panel;
